import { Controller } from '@hotwired/stimulus';
import {
  CHECKOUT_ADDRESS_INPUT_IDS,
  formatAddressFromForm,
  fetchCheckoutTax,
  isCheckoutAddressComplete,
  updateCheckoutTotals,
} from '../lib/checkout_totals';

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.debounceTimer = null;
    this.lastQuotedAddressKey = null;
    this.requestSeq = 0;

    this.boundRecalculateFromEvent = () => this.scheduleRecalculate();
    document.addEventListener(
      'checkout-tax:request',
      this.boundRecalculateFromEvent
    );

    CHECKOUT_ADDRESS_INPUT_IDS.forEach((id) => {
      const input = document.getElementById(id);
      if (!input) return;

      input.addEventListener('input', () => this.handleAddressInput());
      input.addEventListener('change', () => this.scheduleRecalculate());
      input.addEventListener('blur', () => this.scheduleRecalculate());
    });

    this.scheduleRecalculate();
  }

  disconnect() {
    document.removeEventListener(
      'checkout-tax:request',
      this.boundRecalculateFromEvent
    );
    clearTimeout(this.debounceTimer);
  }

  handleAddressInput() {
    const address = formatAddressFromForm();
    const addressKey = JSON.stringify(address);

    if (addressKey === this.lastQuotedAddressKey && isCheckoutAddressComplete(address)) {
      return;
    }

    this.showTaxPending();
  }

  showTaxPending() {
    document.querySelectorAll('.tax-amount').forEach((element) => {
      element.textContent = 'TBD';
    });
  }

  scheduleRecalculate() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => this.recalculate(), 400);
  }

  async recalculate() {
    if (!this.hasUrlValue) return;

    const address = formatAddressFromForm();
    if (!isCheckoutAddressComplete(address)) {
      this.showTaxPending();
      return;
    }

    document.querySelectorAll('.tax-amount').forEach((element) => {
      element.textContent = 'Calculating...';
    });

    const requestId = ++this.requestSeq;
    const totals = await fetchCheckoutTax(this.urlValue, address);
    if (requestId !== this.requestSeq) return;

    if (totals) {
      this.lastQuotedAddressKey = JSON.stringify(address);
      updateCheckoutTotals(totals);
      return;
    }

    this.showTaxPending();
  }
}
